/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsBaseForCostCenterDimension extends models.ServiceAccountNativeDetailsBaseForCostCenter {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsBaseForCostCenterDimension");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsBaseForCostCenterDimension.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsBaseForCostCenterDimension>): ServiceAccountNativeDetailsBaseForCostCenterDimension {
        let obj = Object.assign(new ServiceAccountNativeDetailsBaseForCostCenterDimension(), model);
        ServiceAccountNativeDetailsBaseForCostCenterDimension.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsBaseForCostCenterDimension>): ServiceAccountNativeDetailsBaseForCostCenterDimension {
        if (!model) return null;
        return ServiceAccountNativeDetailsBaseForCostCenterDimension.newInstance(<ServiceAccountNativeDetailsBaseForCostCenterDimension> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsBaseForCostCenterDimension) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsBaseForCostCenterDimension.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsBaseForCostCenterDimension): boolean {
        if (models.ServiceAccountNativeDetailsBaseForCostCenter.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsBaseForCostCenterDimension.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
